import { useCart } from 'hooks/cart/useCart';

export const useCartCount = () => {
  const { data } = useCart();
  const cartCount = data?.totalQuantity || 0;

  return cartCount;
};
